export enum NotificationType {
  Info = "info",
  Error = "error",
  Success = "success"
}
